import _ from 'lodash'
import ObjectSelector from 'scoreboard/components/object-selector'
import ImageGardener from './image-gardener'
import scoreboardUrl from 'scoreboard/components/scoreboard-url'
import imagePreview from './image-preview.hbs'
import appDisplay from 'scoreboard/components/app-display'
import $ from 'jquery'
import projects from 'scoreboard/projects/projects'

var ImageLibraryObjectSelector = ObjectSelector.extend({

	section: 'images',

	ObjectGardener: ImageGardener,

	events: {
		'click .thumbnail': 'onClickThumbnail'
	},

	initialize(options = {}) {
		ObjectSelector.prototype.initialize.apply(this, arguments)
		this.showingAll = false
	},

	showAll() {
		this.showingAll = true
		let projectId = _.result(this.orgGardener, 'getProjectId', projects.id) || ''
		this.objectGardener.show({
			force: true,
			url: `api/images?projectId=${projectId}`
		})
	},

	_onOrgSelect(node) {
		if (this.showingAll) {
			this.objectGardener.show({
				orgId: node.id,
				section: this.section,
				toggleOnSelect: false,
				force: true
			})
			this.showingAll = false
		} else if (!this.objectGardener) {
			this.objectGardener.show({ orgId: node.id })
		} else {
			this.objectGardener.show({
				orgId: node.id,
				section: this.section,
				toggleOnSelect: false
			})
		}
		this.orgGardener.finder.clear()
		this.trigger.apply(this, _.flatten(['selectOrg'].concat(arguments)))
	},

	onClickThumbnail(e) {
		let docId = this.$(e.target).closest('[data-id]').data('id')
		let doc = this.objectGardener.tree.get(docId)
		let url = scoreboardUrl(`api/images/${doc.revisionId}`)

		let body = $('body')
		let bodyWidth = body.width()
		let bodyHeight = body.height()
		let maxContentHeight = bodyHeight - 240 // 240 equals top/bottom padding
		let maxContentWidth = bodyWidth - 140 // 140 equal side padding
		let imageHorizontalRatio = doc.width / doc.height
		let imageVerticalRatio = doc.height / doc.width
		let width, height

		// If image is wider or taller than the dialog, shrink the image's size to be the max width/height
		// it can be while maintaining its proportions and not causing scrollbars.
		if (doc.width > bodyWidth || doc.height > bodyHeight) {
			// If image horizontal/vertical ratio is less than/equal to that of the
			// dialog-content's horizontal/vertical ratio.
			if (imageHorizontalRatio <= maxContentWidth / maxContentHeight) {
				height = maxContentHeight
				width = height * imageHorizontalRatio
			} else {
				width = maxContentWidth
				height = width * imageVerticalRatio
			}
		} else {
			// Otherwise, show the actual dimensions of the image
			width = doc.width
			height = doc.height
		}

		appDisplay.dialog(imagePreview({ url,	width, height }))
	}

})

export default ImageLibraryObjectSelector

ImageLibraryObjectSelector.__filename__ = 'components/files/image-library-object-selector.js'
